import { connect } from 'react-redux'

import AroundTownComponent from './component'

const AroundTownContainer = connect(
  // Map state to props
  (/*state*/) => ({}),
  // Map actions to dispatch and props
  {}
)(AroundTownComponent)

export default AroundTownContainer
